export enum VolleyballStatId {
  // team stats
  YellowCards = 8,
  RedCards = 9,
  Challenges = 109,
  ChallengesCorrect = 110,
  ChallengesIncorrect = 416,
  TeamErrors = 594,
  AttackEfficiency = 803,
  NeutralAttacks = 804,
  PerfectReceptionEfficiency = 805,
  PlusReceptionEfficiency = 808,
  PositiveReceptionEfficiency = 1496,
  OpponentErrors = 814,
  ServiceEfficiency = 1493,
  AttacksBlocked = 1171,

  // person stats
  Appearance = 35,
  FirstAppearance = 816,
  SecondAppearance = 818,
  ThirdAppearance = 820,
  FourthAppearance = 822,
  FifthAppearance = 824,
  PointsRatio = 831,
  GoldenSetAppearance = 1172,

  // team stats & person stats (same id)
  Aces = 48,
  ServiceErrors = 49,
  BlockPoints = 124,
  AttackPoints = 125,
  AttackErrors = 128,
  PointsScored = 595,
  AttackAttempts = 801,
  ServiceAttempts = 802,
  Sets = 1497,
  Digs = 1498,
}
